import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/Geometry/GeometryLevel.png";
import PracticeGame from "../../components/MP_PracticeGame";
import Calculator from "../../components/Calculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { MultiHook } from "tapable";
import { Textfit } from 'react-textfit';
import LiftSign from "../../assets/Measurements/Images/LiftSign.png";
import WeightOnScale from "../../assets/Measurements/Images/WeightonScale.png";
import AimeeOnScale from "../../assets/Measurements/Images/AimeeonScale.png";
import ScramblerOnScale from "../../assets/Measurements/Images/ScrambleronScale.png";
import EmileOnScale from "../../assets/Measurements/Images/EmileonScale.png";
import GemOnScale from "../../assets/Measurements/Images/GemonScale.png";
import DigClock from "../../assets/Measurements/Images/DigClock.png";
import BottleMeasure1 from "../../assets/Measurements/Images/BottleMeasure1.png";
import BottleMeasure2 from "../../assets/Measurements/Images/BottleMeasure2.png";
import BottleMeasure3 from "../../assets/Measurements/Images/BottleMeasure3.png";
import BottleMeasure4 from "../../assets/Measurements/Images/BottleMeasure4.png";
import BottleMeasure5 from "../../assets/Measurements/Images/BottleMeasure5.png";
import BottleMeasure6 from "../../assets/Measurements/Images/BottleMeasure6.png";
import BottleMeasure7 from "../../assets/Measurements/Images/BottleMeasure7.png";
import BottleMeasure8 from "../../assets/Measurements/Images/BottleMeasure8.png";
import BottleMeasure9 from "../../assets/Measurements/Images/BottleMeasure9.png";
import NewRuler20 from "../../assets/Measurements/Images/NewRuler20.png";
import NewRuler30 from "../../assets/Measurements/Images/NewRuler30.png";
import NewRulerRope from "../../assets/Measurements/Images/NewRulerRope.png";
import NewScale from "../../assets/Measurements/Images/NewScale.png";
import NewScaleDial from "../../assets/Measurements/Images/NewScaleDial.png";
import NewScaleDialSmall from "../../assets/Measurements/Images/NewScaleDialSmall.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var qImage;

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function ReturnBottleMeasure(number) {
  if (number == 1) {
    return BottleMeasure1;
  }
  if (number == 2) {
    return BottleMeasure2;
  }
  if (number == 3) {
    return BottleMeasure3;
  }
  if (number == 4) {
    return BottleMeasure4;
  }
  if (number == 5) {
    return BottleMeasure5;
  }
  if (number == 6) {
    return BottleMeasure6;
  }
  if (number == 7) {
    return BottleMeasure7;
  }
  if (number == 8) {
    return BottleMeasure8;
  }
  if (number == 9) {
    return BottleMeasure9;
  }
}

//Generates a question from a default question
function GenerateQuestion(q) {
  console.log(q);
  var key = q.question_key;
  let imageString;
  let questionAnswers = [];

  let correctAnswerImage = "";
  let correctAnswer = q.right_answer;
  let html = "";
  let questionString = q.question;

  function GenerateUniqueRandom(min, max, notthisArray) {
    var returnMe = Math.floor(Math.random() * (max - min) + min);
    console.log(notthisArray)

    if (notthisArray.includes(returnMe)) {
      return GenerateUniqueRandom(min, max, notthisArray);
    }

    return returnMe;
  }

  function GenerateRandom(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  if (q.answer_image == "BottleMeasure" && q.topic_key == "Measurement1") {
    console.log(q);
    correctAnswerImage = "BottleMeasure" + q.right_answer + ".png";
    //push wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: "BottleMeasure" + q.other_answer_1 + ".png"
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_2,
      answerImage: "BottleMeasure" + q.other_answer_2 + ".png"
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_3,
      answerImage: "BottleMeasure" + q.other_answer_3 + ".png"
    });
  }

  else if (q.question_image_a == "LiftSign" && q.topic_key == "Measurement1") {
    /*
    var imageLine = '<img src= {require"../assets/Measurements/Images/'+q.question_image_a+'.png")}';
    //var imageLine = '<img src=\"'+"../assets/Measurements/Images/"+q.question_image_a+".png"+'\"\">'
    html = imageLine+
    'style={{ position: "relative", top: "-100%", right: "15%" zIndex: "-1"}}></img>'+
  "<div className='centered'>"+1+"</div>"
  //html = ReturnImageDiv();
  html = '<img src={$LiftSign} ></img>'*/
    var liftAnswer = (Math.floor(Math.random() * (20 - 5) + 5));
    correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(5, 20, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer,
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(5, 20, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer,
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(5, 20, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer,
      answerImage: ""
    });

    html = '<img src="' + LiftSign + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:40px ; position:absolute ; top:52% ; right:61%'>" + liftAnswer + "</div>";
  }

  else if (q.question_image_a == "BottleMeasure" && q.topic_key == "Measurement1") {
    //generate correct answer
    var answerNum = Math.floor(Math.random() * (10 - 1) + 1);
    var usedAnswers = [];
    usedAnswers.push(answerNum);
    correctAnswer = answerNum + "L";
    //generate wrong answers
    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "L",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "L",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "L",
      answerImage: ""
    });
    imageString = "BottleMeasure" + answerNum + ".png"
  }

  //LONGEST LINE
  else if (q.answer_image == "LineMeasure" && q.question_key == "Measurement2Q1") {
    var genAnswer = GenerateRandom(7, 10);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "LineMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(1, 3, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
  }
  //LONGEST ROPE

  else if (q.question_key == "Measurement2Q2") {
    var genAnswer = GenerateRandom(7, 10);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "RopeMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(1, 3, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });

  }
  //SHORTEST LINE
  else if (q.answer_image == "LineMeasure" && q.question_key == "Measurement2Q3") {
    var genAnswer = GenerateRandom(1, 3);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "LineMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(7, 10, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LineMeasure" + genAnswer + ".png"
    });
  }

  //SHORTEST ROPE

  else if (q.question_key == "Measurement2Q4") {
    var genAnswer = GenerateRandom(1, 3);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "RopeMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(7, 10, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "RopeMeasure" + genAnswer + ".png"
    });
  }

  //EMILE HEIGHT TALL

  else if (q.question_key == "Measurement2Q5") {
    var genAnswer = GenerateRandom(7, 10);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "EmileHeight" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(1, 3, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
  }

  //EMILE HEIGHT SHORT

  else if (q.question_key == "Measurement2Q6") {
    var genAnswer = GenerateRandom(1, 3);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "EmileHeight" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(7, 10, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "EmileHeight" + genAnswer + ".png"
    });
  }

  //LADER HEIGHT TALL

  else if (q.question_key == "Measurement2Q7") {
    var genAnswer = GenerateRandom(7, 10);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "LadderMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(1, 3, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
  }

  //LADDER HEIGHT SHORT

  else if (q.question_key == "Measurement2Q8") {
    var genAnswer = GenerateRandom(1, 3);
    var usedAnswers = [];
    usedAnswers.push(genAnswer);
    correctAnswer = genAnswer + "cm";
    correctAnswerImage = "LadderMeasure" + genAnswer + ".png";

    //generate wrong answers
    genAnswer = GenerateUniqueRandom(3, 5, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(5, 7, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
    //generate wrong answers
    genAnswer = GenerateUniqueRandom(7, 10, usedAnswers);
    usedAnswers.push(genAnswer);
    questionAnswers.push({
      correct: false,
      value: genAnswer + "cm",
      answerImage: "LadderMeasure" + genAnswer + ".png"
    });
  }

  //How tall is Emile?
  else if (q.question_key == "Measurement3Q1") {
    var height = GenerateRandom(5, 10);
    correctAnswer = height + "cm";
    var usedAnswers = [];
    usedAnswers.push(height);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    imageString = "EmileHeight" + height + ".png"
  }

  //how tall is Scrambler?
  else if (q.question_key == "Measurement3Q2") {
    var height = GenerateRandom(5, 10);
    correctAnswer = height + "cm";
    var usedAnswers = [];
    usedAnswers.push(height);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    imageString = "ScramblerHeight" + height + ".png"
  }

  //HOW LONG IS THE LINE
  else if (q.question_key == "Measurement3Q3") {
    var height = GenerateRandom(5, 10);
    correctAnswer = height + "cm";
    var usedAnswers = [];
    usedAnswers.push(height);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "cm",
      answerImage: ""
    });

    imageString = "LineMeasure" + height + ".png"
  }

  //HOW LONG IS THE ROPE
  //HOW LONG IS THE LINE
  else if (q.question_key == "Measurement3Q4") {
    var height = GenerateRandom(5, 10);
    correctAnswer = height + "m";
    var usedAnswers = [];
    usedAnswers.push(height);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "m",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "m",
      answerImage: ""
    });

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "m",
      answerImage: ""
    });

    imageString = "RopeMeasure" + height + ".png"
  }
  //heavier than 5kg
  else if (q.question_key == "Measurement4Q1") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(6, 10);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 5, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 5, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 5, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET HEAVIEST
    var heaviest = Math.max.apply(null, usedAnswers);
    console.log(heaviest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == heaviest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + WeightOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:9% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //lighter than 5kg
  else if (q.question_key == "Measurement4Q2") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 4);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(5, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(5, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(5, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET HEAVIEST
    var lightest = Math.min.apply(null, usedAnswers);
    console.log(lightest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == lightest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + WeightOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:9% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //heaviest weight
  else if (q.question_key == "Measurement4Q3") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 10);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET HEAVIEST
    var heaviest = Math.max.apply(null, usedAnswers);
    console.log(heaviest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == heaviest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + WeightOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:9% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //lightest weight
  else if (q.question_key == "Measurement4Q4") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 10);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);
    console.log(usedAnswers);

    //GET HEAVIEST
    var heaviest = Math.min.apply(null, usedAnswers);
    console.log(heaviest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == heaviest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + WeightOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:9% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //heaviest weight AIMEE
  else if (q.question_key == "Measurement4Q5") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 10);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET HEAVIEST
    var heaviest = Math.max.apply(null, usedAnswers);
    console.log(heaviest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == heaviest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + AimeeOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:10% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //lightest weight AIMEE
  else if (q.question_key == "Measurement4Q6") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 10);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET HEAVIEST
    var heaviest = Math.min.apply(null, usedAnswers);
    console.log(heaviest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == heaviest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 84.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + AimeeOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:40px ; color:white; position:absolute ; top:10% ; right:" + rightPos + "%'>" + letterArray[i].number + "kg" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  else if (q.question_key == "Measurement4Q7") {
    var liftAnswer = GenerateRandom(1, 10)
    correctAnswer = liftAnswer + "kg";
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    html = '<img src="' + EmileOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:40px ; color: white; position:absolute ; top:15% ; right:39%'>" + liftAnswer + "kg" + "</div>";
  }
  else if (q.question_key == "Measurement4Q8") {
    var liftAnswer = GenerateRandom(1, 10)
    correctAnswer = liftAnswer + "kg";
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 10, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    html = '<img src="' + ScramblerOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:40px ; color: white; position:absolute ; top:23% ; right:39%'>" + liftAnswer + "kg" + "</div>";
  }

  else if (q.question_key == "Measurement4Q9") {
    var liftAnswer = GenerateRandom(100, 1000)
    correctAnswer = liftAnswer + "kg";
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 1000, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 1000, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 1000, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + "kg",
      answerImage: ""
    });

    html = '<img src="' + GemOnScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:24px ; color: white; position:absolute ; top:13% ; right:37%'>" + liftAnswer + "kg" + "</div>";
  }

  else if (q.topic_key == "Measurement5") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_2,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_3,
      answerImage: ""
    });

    imageString = q.question_image_a + ".png";

  }

  //earliest time AIMEE
  else if (q.question_key == "Measurement6Q1") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 12);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET EARLIEST
    var earliest = Math.min.apply(null, usedAnswers);
    console.log(earliest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == earliest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 90.5 - minus;
      var rightposRight = 80.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + DigClock + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:50px ; position:absolute ; top:38% ; right:" + rightPos + "%'>" + letterArray[i].number + "</div>" +
        "<div style='font-size:50px ; position:absolute ; top:38% ; right:" + rightposRight + "%'>" + "00" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //latest time AIMEE
  else if (q.question_key == "Measurement6Q2") {
    //DO THE ABCD THING!
    var liftAnswer = GenerateRandom(1, 12);
    //correctAnswer = liftAnswer;
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);

    //then randomise the order
    usedAnswers = shuffleArray(usedAnswers);

    //GET LATESST
    var earliest = Math.max.apply(null, usedAnswers);
    console.log(earliest);

    //assign each one a letter
    var letterArray = [];
    for (let i = 0; i < usedAnswers.length; i++) {
      letterArray.push({
        number: usedAnswers[i],
        letter: String.fromCharCode(65 + i)
      })
      if (usedAnswers[i] == earliest) {
        correctAnswer = String.fromCharCode(65 + i);
      } else {
        questionAnswers.push({
          correct: false,
          value: String.fromCharCode(65 + i),
          answerImage: ""
        })
      }
    }
    html = "<div>";
    for (let i = 0; i < letterArray.length; i++) {
      var minus = i * 25;
      var rightPos = 90.5 - minus;
      var rightposRight = 80.5 - minus;
      var lowerRightPos = 86.5 - minus;
      html += '<img src="' + DigClock + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
        "<div style='font-size:50px ; position:absolute ; top:38% ; right:" + rightPos + "%'>" + letterArray[i].number + "</div>" +
        "<div style='font-size:50px ; position:absolute ; top:38% ; right:" + rightposRight + "%'>" + "00" + "</div>" +
        "<div style='font-size:40px ; color:white; position:absolute ; top:80% ; right:" + lowerRightPos + "%'>" + letterArray[i].letter + "</div>"
    }
    html += "</div>";
  }

  //clock
  else if (q.topic_key == "Measurement6" && q.question_image_a == "DigClock") {
    var liftAnswer = GenerateRandom(1, 12)
    correctAnswer = liftAnswer + " o'clock";
    var usedAnswers = [];
    usedAnswers.push(liftAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    html = '<img src="' + DigClock + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; position:absolute ; top:38% ; right:60.5%'>" + liftAnswer + "</div>" +
      "<div style='font-size:50px ; position:absolute ; top:38% ; right:20.5%'>" + "00" + "</div>";
  }

  else if (q.question_key == "Measurement6Q14" || q.question_key == "Measurement6Q15" || q.question_key == "Measurement6Q47") {
    //generate correct answer
    var answerNum = GenerateRandom(1, 12);
    var usedAnswers = [];
    usedAnswers.push(answerNum);
    correctAnswer = answerNum + " o'clock";
    //generate wrong answers
    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    imageString = "Clock" + answerNum + ".png"
  }

  else if ((q.topic_key == "Measurement6" || q.topic_key == "Measurement13") && q.question_image_a == "" && q.answer_image == "") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_2,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: q.other_answer_3,
      answerImage: ""
    });
  }

  //A GREATER THAN B
  else if (q.question_key == "Measurement7Q1") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var bottleA = GenerateRandom(6, 10);
    var bottleB = GenerateRandom(1, 5);
    //show image

    ReturnBottleMeasure(bottleB);

    html = '<img src="' + ReturnBottleMeasure(bottleA) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:90% ; right:72.5%'>" + "A" + "</div>" +
      '<img src="' + ReturnBottleMeasure(bottleB) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:90% ; right:22.5%'>" + "B" + "</div>"
  }

  //B GREATER THAN A
  else if (q.question_key == "Measurement7Q2") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var bottleB = GenerateRandom(6, 10);
    var bottleA = GenerateRandom(1, 5);
    //show image

    html = '<img src="' + ReturnBottleMeasure(bottleA) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:90% ; right:72.5%'>" + "A" + "</div>" +
      '<img src="' + ReturnBottleMeasure(bottleB) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:90% ; right:22.5%'>" + "B" + "</div>"
  }

  //length of rope
  else if (q.question_key == "Measurement8Q1") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var RopeA = GenerateRandom(12, 20);
    console.log(RopeA);
    var RopeB = GenerateRandom(25, 30);
    //show image

    html = '<img src="' + NewRuler20 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:60% ; transform: scale(1," + (0.37 + ((RopeA - 10) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewRuler30 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:10% ; transform: scale(1," + (0.37 + ((RopeB - 20) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:22.5%'>" + "B" + "</div>"
  }

  //length of rope
  else if (q.question_key == "Measurement8Q2") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var RopeA = GenerateRandom(25, 30);
    var RopeB = GenerateRandom(12, 20);
    //show image

    html = '<img src="' + NewRuler20 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:60% ; transform: scale(1," + (0.37 + ((RopeA - 20) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewRuler30 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:10% ; transform: scale(1," + (0.37 + ((RopeB - 10) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:22.5%'>" + "B" + "</div>"
  }

  //emile is $ tall
  else if (q.question_key == "Measurement8Q3") {
    let emile = Math.ceil(GenerateRandom(50, 100) / 10) * 10;
    let ans = emile / 2;

    questionString = q.question.replace("$", emile.toString());
    var usedAnswers = [];
    usedAnswers.push(ans);
    let wrong1 = GenerateUniqueRandom(50, 100, usedAnswers);
    usedAnswers.push(wrong1);
    let wrong2 = GenerateUniqueRandom(50, 100, usedAnswers);
    usedAnswers.push(wrong2);
    let wrong3 = GenerateUniqueRandom(50, 100, usedAnswers);
    usedAnswers.push(wrong3);

    correctAnswer = ans + "cm";
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: wrong1 + "cm",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong2 + "cm",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong3 + "cm",
      answerImage: ""
    });
  }

  //mass A greater than or less than B
  else if (q.question_key == "Measurement9Q1") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var WeightA = GenerateRandom(1, 5);
    var WeightB = GenerateRandom(6, 10);
    //show image
    var Rotation = -154;

    html = '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:67% ;  transform:rotate(" + (Rotation + (30.45 * WeightA)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:16.5% ;  transform:rotate(" + (Rotation + (30.45 * WeightB)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:22.5%'>" + "B" + "</div>"
  }

  //mass A greater than or less than B
  else if (q.question_key == "Measurement9Q2") {
    correctAnswer = q.right_answer;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: q.other_answer_1,
      answerImage: ""
    });
    var WeightA = GenerateRandom(6, 10);
    var WeightB = GenerateRandom(1, 5);
    //show image
    var Rotation = -154;

    html = '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:67% ;  transform:rotate(" + (Rotation + (30.45 * WeightA)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:16.5% ;  transform:rotate(" + (Rotation + (30.45 * WeightB)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:95% ; right:22.5%'>" + "B" + "</div>"
  }

  //emile is $ weigh
  else if (q.question_key == "Measurement9Q3") {
    let emile = GenerateRandom(1, 12);
    let ans = emile * 2;

    questionString = q.question.replace("$", emile.toString());
    var usedAnswers = [];
    usedAnswers.push(ans);
    let wrong1 = GenerateUniqueRandom(2, 24, usedAnswers);
    usedAnswers.push(wrong1);
    let wrong2 = GenerateUniqueRandom(2, 24, usedAnswers);
    usedAnswers.push(wrong2);
    let wrong3 = GenerateUniqueRandom(2, 24, usedAnswers);
    usedAnswers.push(wrong3);

    correctAnswer = ans + "kg";
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: wrong1 + "kg",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong2 + "kg",
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong3 + "kg",
      answerImage: ""
    });
  }

  //B GREATER THAN A
  else if (q.question_key == "Measurement10Q1") {
    var bottleB = GenerateRandom(1, 10);
    var bottleA = GenerateRandom(1, 10);
    var sum = bottleA + bottleB
    correctAnswer = sum + "l";
    //wrong answer
    var usedAnswers = [];
    usedAnswers.push(sum);
    //generate wrong answers
    var wrong = GenerateUniqueRandom(2, 20, usedAnswers)
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "l",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(2, 20, usedAnswers)
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "l",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(2, 20, usedAnswers)
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "l",
      answerImage: ""
    });

    //show image
    html = '<img src="' + ReturnBottleMeasure(bottleA) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:80% ; right:72.5%'>" + "A" + "</div>" +
      '<img src="' + ReturnBottleMeasure(bottleB) + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:80% ; right:22.5%'>" + "B" + "</div>"
  }

  //length of rope combine
  else if (q.question_key == "Measurement11Q1") {

    var RopeA = GenerateRandom(11, 20);
    var RopeB = GenerateRandom(11, 20);

    var sum = RopeA + RopeB;
    correctAnswer = sum + "m"
    var usedAnswers = [];
    usedAnswers.push(sum);
    //generate wrong answers
    var wrong = GenerateUniqueRandom(22, 40, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "m",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(22, 40, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "m",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(22, 40, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "m",
      answerImage: ""
    });
    //show image
    html = '<img src="' + NewRuler20 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:60% ; transform: scale(1," + (0.37 + ((RopeA - 10) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:75% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewRuler20 + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewRulerRope + '"' + "style='position:absolute ; right:10% ; transform: scale(1," + (0.37 + ((RopeB - 10) * 0.06)).toString() + ") ; transform-origin: 50% 100%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:75% ; right:22.5%'>" + "B" + "</div>"
  }

  //scales combined
  else if (q.question_key == "Measurement12Q1") {

    var WeightA = GenerateRandom(1, 10);
    var WeightB = GenerateRandom(1, 10);

    var sum = WeightA + WeightB;
    correctAnswer = sum + "kg"
    var usedAnswers = [];
    usedAnswers.push(sum);
    //generate wrong answers
    var wrong = GenerateUniqueRandom(2, 20, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "kg",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(2, 20, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "kg",
      answerImage: ""
    });
    wrong = GenerateUniqueRandom(2, 20, usedAnswers);
    usedAnswers.push(wrong);
    questionAnswers.push({
      correct: false,
      value: wrong + "kg",
      answerImage: ""
    });
    var Rotation = -154;

    html = '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:67% ;  transform:rotate(" + (Rotation + (30.45 * WeightA)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:85% ; right:72.5%'>" + "A" + "</div>" +

      '<img src="' + NewScale + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      '<img src="' + NewScaleDialSmall + '"' + "style='position:absolute ; right:16.5% ;  transform:rotate(" + (Rotation + (30.45 * WeightB)).toString() + "deg);  top:46%;  transform-origin: 50% 50%;  zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; color:white; position:absolute ; top:85% ; right:22.5%'>" + "B" + "</div>"
  }

  else if (q.question_key == "Measurement13Q1") {
    var liftAnswer = GenerateRandom(1, 24)
    var modAnswer;
    if (liftAnswer > 12) {
      modAnswer = (liftAnswer - 12)
    } else {
      modAnswer = liftAnswer;
    }
    correctAnswer = modAnswer + " o'clock";

    var usedAnswers = [];
    usedAnswers.push(modAnswer);

    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });

    html = '<img src="' + DigClock + '"' + "style='position:relative ; right:0% ; zIndex:-1'" + '></img>' +
      "<div style='font-size:50px ; position:absolute ; top:38% ; right:60.5%'>" + liftAnswer + "</div>" +
      "<div style='font-size:50px ; position:absolute ; top:38% ; right:20.5%'>" + "00" + "</div>";
  }

  else if (q.question_key == "Measurement13Q2") {
    //generate correct answer
    var answerNum = GenerateRandom(1, 12);
    var usedAnswers = [];
    usedAnswers.push(answerNum);
    correctAnswer = answerNum + " o'clock";
    //generate wrong answers
    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    imageString = "Clock" + answerNum + ".png"
  }

  else if (q.question_key == "Measurement13Q3") {
    //generate correct answer
    var answerNum = GenerateRandom(1, 12);
    var usedAnswers = [];
    usedAnswers.push(answerNum);
    correctAnswer = answerNum + " o'clock";
    //generate wrong answers
    var wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    wrongAnswer = GenerateUniqueRandom(1, 12, usedAnswers);
    usedAnswers.push(wrongAnswer);
    questionAnswers.push({
      correct: false,
      value: wrongAnswer + " o'clock",
      answerImage: ""
    });
    imageString = "RomClock" + answerNum + ".png"
  }

  //how many millimeters are in $ litres
  //what is $ kilometers in meters
  //how many grams
  else if (q.question_image_a == "" && q.question.includes("^") == false && q.question_key != "Measurement24Q1") {

    var split = q.question_image_a_value.split("/");
    console.log(split);

    let emile = GenerateRandom(parseInt(split[0]), parseInt(split[1]));
    let emileDec = 0;

    if (parseFloat(split[2]) < 1) {
      emileDec = GenerateRandom(1, 9) / 10;
      emile = emile + emileDec;
    }

    /*
    //round it
    var emileRound = parseFloat(split[2]);
    console.log(emileRound);
    emile = Math.round(emile / emileRound) * emileRound
    console.log(emile);*/

    emile = parseFloat(emile.toFixed(2));//fix bugs

    //get multiplier
    var mult;


    let ans;
    var divide = false;
    if (q.right_answer.includes("/")) {
      mult = q.right_answer.replace("ImageValue/", "");
      ans = emile / parseInt(mult);
      divide = true;
      console.log("divide");
    }
    else {
      mult = q.right_answer.replace("ImageValue*", "");
      ans = emile * parseInt(mult);
    }


    var wrongSplit = q.other_answer_1.split("/");
    if (q.question_key == "Measurement22Q2") {
      console.log(wrongSplit.length);
    }
    var round;
    if (wrongSplit.length >= 3) {
      round = 1;
    } else {
      round = parseFloat(wrongSplit[2]);
    }

    if (divide)
      console.log(round);

    questionString = q.question.replace("$", emile.toString());
    var usedAnswers = [];
    usedAnswers.push(ans);
    let wrong1 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    if (divide == true)
      console.log(wrong1);
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      wrong1 = wrong1 + emileDec;
    }
    wrong1 = Math.round(wrong1 / round) * round
    usedAnswers.push(wrong1);
    let wrong2 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      wrong2 = wrong2 + emileDec;
    }
    wrong2 = Math.round(wrong2 / round) * round
    usedAnswers.push(wrong2);
    let wrong3 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    console.log(wrong3);
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      wrong3 = wrong3 + emileDec;
    }
    console.log(wrong3);
    wrong3 = Math.round(wrong3 / round) * round
    usedAnswers.push(wrong3);


    var append = split[3].replace("(", "");
    append = append.replace(")", "");

    correctAnswer = ans + append;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: wrong1 + append,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong2 + append,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong3 + append,
      answerImage: ""
    });
  }


  //How many millilitres are in $ litres ^ millilitres?
  else if (q.question.includes("^") == true && q.question_image_a == "") {
    var split = q.question_image_a_value.split("/");
    console.log(split);

    let emile = GenerateRandom(parseInt(split[0]), parseInt(split[1]));
    let emileDec = 0;

    if (parseFloat(split[2]) < 1) {
      emileDec = GenerateRandom(1, 9) / 10;
      emile = emile + emileDec;
    }
    //NEW ADDITION
    let secondSplit = q.question_image_b_value.split("/");
    let otherValue = GenerateRandom(secondSplit[0], secondSplit[1])
    console.log(otherValue);
    //add new addition to value to create answer

    //round it
    var emileRound = parseFloat(split[2]);
    console.log(emileRound);
    emile = Math.round(emile / emileRound) * emileRound
    console.log(emile);

    //get multiplier
    var mult = q.right_answer.replace("ImageValue*", "");
    let ans = emile * parseInt(mult);
    //add new addition to value to create answer
    ans += otherValue

    var wrongSplit = q.other_answer_1.split("/");
    if (q.question_key == "Measurement22Q2") {
      console.log(wrongSplit.length);
    }
    var round;
    if (wrongSplit.length >= 3) {
      round = 1;
    } else {
      round = parseFloat(wrongSplit[2]);
    }

    questionString = q.question.replace("$", emile.toString());
    var usedAnswers = [];
    usedAnswers.push(ans);
    let wrong1 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      wrong1 = wrong1 + emileDec;
    }
    wrong1 = Math.round(wrong1 / round) * round
    usedAnswers.push(wrong1);
    let wrong2 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      wrong2 = wrong2 + emileDec;
    }
    wrong2 = Math.round(wrong2 / round) * round
    usedAnswers.push(wrong2);
    let wrong3 = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
    console.log(wrong3);
    if (parseFloat(split[2]) < 1) {
      emileDec = (GenerateRandom(1, 9) / 10) * mult;
      console.log(emileDec);
      wrong3 = wrong3 + emileDec;
    }
    console.log(wrong3);
    wrong3 = Math.round(wrong3 / round) * round
    usedAnswers.push(wrong3);



    var append;
    if (split.length >= 4) {
      append = split[3].replace("(", "");
      append = append.replace(")", "");
    }

    questionString = q.question.replace("$", emile.toString());
    questionString = questionString.replace("^", otherValue.toString());


    correctAnswer = ans + append;
    //generate wrong answers
    questionAnswers.push({
      correct: false,
      value: wrong1 + append,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong2 + append,
      answerImage: ""
    });
    questionAnswers.push({
      correct: false,
      value: wrong3 + append,
      answerImage: ""
    });
  }

  else if (q.question_key == "Measurement23Q1" || q.question_key == "Measurement23Q2" || q.question_key == "Measurement25Q1") {
    imageString = q.question_image_a + ".png";
    let answer;

    if (q.question.includes("$") && q.question.includes("^") && q.question.includes("*") == false && q.question_key != "Measurement25Q1") {
      let valueA = GenerateRandom(1, 10);
      let valueB = GenerateRandom(1, 10);
      answer = valueA * valueB;

      questionString = q.question.replace("$", valueA.toString());
      questionString = questionString.replace("^", valueB.toString());

      var wrongSplit = q.other_answer_1.split("/");

      correctAnswer = answer + "cm²";
      var usedAnswers = [];
      usedAnswers.push(answer);

      for (let i = 0; i < 3; i++) {
        var ans = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
        usedAnswers.push(ans);
        questionAnswers.push({
          correct: false,
          value: ans + "cm²",
          answerImage: ""
        });
      }
    }

    else if (q.question.includes("$") && q.question.includes("^") && q.question.includes("*") == true && q.question_key != "Measurement25Q1") {
      let valueA = GenerateRandom(1, 10);
      let valueB = GenerateRandom(1, 10);
      let valueC = GenerateRandom(1, 10);
      answer = valueA * valueB * valueC;

      questionString = q.question.replace("$", valueA.toString());
      questionString = questionString.replace("^", valueB.toString());
      questionString = questionString.replace("*", valueC.toString());

      var wrongSplit = q.other_answer_1.split("/");

      correctAnswer = answer + "cm³";
      var usedAnswers = [];
      usedAnswers.push(answer);

      for (let i = 0; i < 3; i++) {
        var ans = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
        usedAnswers.push(ans);
        questionAnswers.push({
          correct: false,
          value: ans + "cm³",
          answerImage: ""
        });
      }
    }
    else {
      let valueA = GenerateRandom(1, 10);
      let valueB = GenerateRandom(1, 10);
      answer = (valueA * 2) + (valueB * 2);

      questionString = q.question.replace("$", valueA.toString());
      questionString = questionString.replace("^", valueB.toString());

      var wrongSplit = q.other_answer_1.split("/");

      correctAnswer = answer + "cm";
      var usedAnswers = [];
      usedAnswers.push(answer);

      for (let i = 0; i < 3; i++) {
        var ans = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
        usedAnswers.push(ans);
        questionAnswers.push({
          correct: false,
          value: ans + "cm",
          answerImage: ""
        });
      }

    }
  }

  else if (q.question_key == "Measurement24Q1") {
    var value = GenerateRandom(1, 10);
    questionString = q.question.replace("$", value.toString());
    var answer = value * 0.62;
    correctAnswer = answer.toFixed(2) + " miles";
    var usedAnswers = [];
    usedAnswers.push(answer);
    console.log("HELP")

    var wrongSplit = q.other_answer_1.split("/");

    for (let i = 0; i < 3; i++) {
      var ans = GenerateUniqueRandom(parseInt(wrongSplit[0]), parseInt(wrongSplit[1]), usedAnswers)
      var dec = GenerateRandom(1, 99) / 100
      usedAnswers.push(ans);
      questionAnswers.push({
        correct: false,
        value: (ans + dec).toFixed(2) + " miles",
        answerImage: ""
      });
    }

  }

  questionAnswers.push({
    correct: true,
    value: correctAnswer,
    answerImage: correctAnswerImage
  });

  shuffleArray(questionAnswers);

  let question = {
    question: questionString,
    answers: questionAnswers,
    image: imageString,
    questionHTML: html
  }


  return question;
}
export default function Multiplayer({ ...props }) {
  const game = props.game;
  console.log(props);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([,]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  //const [realQuestions, setRealQuestions] = useState();
  const [workAround, setWorkAround] = useState(false);
  const [place, setPlace] = useState(0);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value.correct) {
      //correct answer
      setCorrectQuestions([...correctQuestions, currentQuestion]);
      let multiplier = combo > 0 ? combo + 1 : 1;
      multiplier = multiplier > 5 ? 5 : multiplier;
      setScore(score + multiplier * 10);
      if (multiplier != 0 && multiplier != undefined)
        props.SubmitScore(multiplier * 10);


      if (combo < 99) {
        setCombo(combo + 1);
      }
      if (combo > maxCombo) {
        setMaxCombo(combo);
      }
      newQuestion();
    }
    //incorrect answer
    else {
      isCorrect = false;
      setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
      if (combo === 0 && score >= 10) {
        setScore(score - 10);
        props.SubmitScore(-10)
      } else {
        setCombo(0);
      }

      let result = {
        question: currQuestion.question,
        correct: currQuestion.correct,
        incorrect: value.value
      };

      setFeedback([...feedback, result]);
      setColouredFeedback(true);
      setWaitTime(2);
    }

    //Generates a new question
    //newQuestion();
  }

  function GetListOfPositions() {
    //order the scores
    //console.log(props);
    //var web = props.parent.getwebrtc();
    var web = props.ReturnScores();
    console.log(web);
    var webcopy = JSON.parse(JSON.stringify(web));
    // console.log(webcopy);
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    //console.log(webcopy);
    //replace yourname with YOU
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username)
        webcopy[i].username = "You"
    }
    var scoreText = [];
    for (let i = 0; i < webcopy.length; i++) {
      let temptext = webcopy[i].username + ": " + webcopy[i].score
      scoreText.push(temptext);
    }
    // console.log(scoreText);
    const listItems = scoreText.map((i) =>
      <li>{i}</li>
    );

    return listItems;
  }

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    var difficulty = Math.floor(Math.random() * questions.length);
    var questionNum = Math.floor(Math.random() * questions[difficulty].length)
    currQuestion = GenerateQuestion(questions[difficulty][questionNum]);;
    console.log(questions[difficulty][questionNum])
    console.log(currQuestion);
    setCurrentQuestion(currQuestion);
    CheckImage()
    return currQuestion;
  }

  function CheckImage() {
    if (currQuestion.image != "" && currQuestion.image != undefined) {
      console.log(currQuestion.image);
      var currImage = currQuestion.image;
      var correctAnswerName;
      //gets correct answer name for testing
      console.log(currQuestion);
      for (let i = 0; i < currQuestion.answers.length; i++) {
        if (currQuestion.answers[i].correct == true)
          correctAnswerName = currQuestion.answers[i].value;
      }
      var imagePath = currImage.replace(".jpg", ".png");
      console.log(imagePath)
      currQuestion.image = imagePath;
    }
  }

  function GetPlace() {
    var position = 0;
    //order the scores
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    console.log(webcopy);
    //gets your position in the list
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username) {
        setPlace(i + 1);
        position = i + 1;
      }

    }
    console.log(place);
    console.log(position);
    return position;
  }

  if ((currentQuestion.image != "" && currentQuestion.image != undefined)) {
    qImage = require('../../assets/Measurements/Images/' + currentQuestion.image);
  }

  function MultipleButtons() {
    console.log(currentQuestion);

    return FilteredAnswers().map(answer => (

      <Button
        {...console.log(answer)}
        value={<div dangerouslySetInnerHTML={answer.value} />}
        style={{ flex: 1, margin: "20px" }}
        onClick={() => checkResult(answer, true)}
      >
        {answer.answerImage == "" ? (
          <div style={{ height: "80%", width: "100%" }}>
            <Textfit mode="multi" max="60" style={{ height: "80%", textAlign:"center", padding:"5px 50px" }}>
              {answer.value}
            </Textfit>
          </div>
        ) : (
            <ButtonImage src={require("../../assets/Measurements/Images/" + answer.answerImage)} ></ButtonImage>
          )
        }
      </Button>
    ))

  }

  function MultipleFeedbackButtons() {
    console.log(currentQuestion);

    return FilteredAnswers().map(answer => (

      <Button
        {...console.log(answer)}
        value={<div dangerouslySetInnerHTML={answer.value} />}
        style={{ flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
      >
        {answer.answerImage == "" ? (
          <div style={{ height: "80%", width: "100%" }}>
            <Textfit mode="multi" max="60" style={{ height: "80%", textAlign:"center", padding:"5px 50px" }}>
              {answer.value}
            </Textfit>
          </div>
        ) : (
            <ButtonImage src={require("../../assets/Measurements/Images/" + answer.answerImage)} ></ButtonImage>
          )
        }
      </Button>
    ))

  }

  function FilteredAnswers() {
    if (currentQuestion.answers != undefined) {
      return currentQuestion.answers.filter(v => v.value !== "");
    }
    return currentQuestion;
  }

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions)
      setCurrentQuestion(newQuestion())
    }
  }, [questions]);

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
        comboNum = 4;
    var imageName = props.game.animation_path + "/combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    console.log("../../assets/"+imageName)

        return (require("../../assets/"+imageName))

}


  return (
    <PracticeGame
    parent={props}
      loading={!questions}
      correct={correctQuestions}
      incorrect={incorrectQuestions}
      score={score}
      onBack={() => props.onBack()}
      defaultTimer={60}
      restart={() => {
        setCombo(0);
        setScore(0);
        setCorrectQuestions([]);
        setIncorrectQuestions([]);
      }}
      feedback={feedback}
      homework_id={props.homework_id}
      getplace={() => GetPlace()}
    >
       <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
      <Body>
        <FormContent style={{ right: "100px", top: "0px", width: "200px", height: "50%" }}>
          <br></br>
          {GetListOfPositions()}
        </FormContent>
        <div>{currQuestion !== undefined ? (


          <Container>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Question
                type="text"
                disabled
                javaScriptEnabled={true}
                //I don't know if this does anything
                value={
                  currQuestion.question !== undefined
                    ? <div dangerouslySetInnerHTML={((currQuestion.question.replace("$", "?")))} />
                    : ""
                }
              >
                <div dangerouslySetInnerHTML={{ __html: (currQuestion.question) }} />
              </Question>
            </div>
            <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
              {(currentQuestion.image != "" && currentQuestion.image != undefined) && currentQuestion.questionHTML == "" ? (
                <img src={qImage}></img>
                /*<img src = {image} className ={style.geoImg} filter = {hue-rotate(60deg);}></img>*/
              ) : (
                  <div></div>
                )}
              {currentQuestion.questionHTML != "" ? (
                //<div dangerouslySetInnerHTML={{__html: currentQuestion.questionHTML}}></div>
                //<div><img src={require("../assets/Measurements/Images/LiftSign.png")}></img></div>
                //<div innerHtml={currentQuestion.questionHTML}></div>
                <DynamicStyle>
                  <div dangerouslySetInnerHTML={{ __html: currentQuestion.questionHTML }}></div>
                </DynamicStyle>
              ) :
                (
                  <div></div>
                )}
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between"
                }}
              >
                {showColouredFeedback == false && currQuestion.answers !== undefined &&
                  <div style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between"
                  }}>
                    {MultipleButtons()}
                  </div>}

                  {showColouredFeedback == true && currQuestion.answers !== undefined &&
                  <div style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between"
                  }}>
                    {MultipleFeedbackButtons()}
                  </div>}
              </div>
            </div>
          </Container>

        ) : <h1>help</h1>}
        </div>
        <Combo>
          <span style={{ fontSize: "50px" }}>{combo}</span>
          <span style={{ fontSize: "20px" }}>COMBO</span>
        </Combo>
      </Body>
      </div>
    </PracticeGame>
  );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url();
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 40px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  font-size: 2em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }


`;

const Question = styled.div`
  background: #E9E9E9;
  user-select: none;
  width: 40em;
  line-height: 35px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 20px 0px 20px;
  `;

const Button = styled.div`
  text-align: center;
  width: 20%;
  height: 150px;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const Container = styled.div`
width:100%%;
height:75%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom:100px;
`;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`

const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
  position: realtive;
  top: 35%;
  //left: -15%;
  //width: 100%
  //text-align: center
  font-size 2em;
  //50%
`;
